<template>
  <div class="flex-column" :class="$attrs.class">
    <div class="color-secondary-6 font-14">
      {{ label }}
    </div>
    <div class="color-black font-16">
      {{ displayValue }}
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'InfoField',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number, Object, Date],
      default: null,
    },
    fallback: {
      type: String,
      default: '-',
    },
    formatter: {
      type: Function,
      default: null,
    },
    formatType: {
      type: String,
      default: '',
    },
  },
  computed: {
    displayValue() {
      if (this.formatter) {
        return this.formatter(this.value);
      }

      if (
        this.value === null ||
        this.value === undefined ||
        this.value === ''
      ) {
        return this.fallback;
      }

      if (typeof this.value === 'object') {
        if (
          this.value?.name !== undefined &&
          this.value?.name !== null &&
          this.value?.name !== ''
        ) {
          return this.applyFormat(this.value?.name);
        }

        return this.fallback;
      }

      return this.applyFormat(this.value);
    },
  },
  methods: {
    applyFormat(value) {
      switch (this.formatType) {
        case 'date':
          return this.formatDate(value);
        case 'phone':
          return this.formatPhone(value);
        case 'postal-code':
          return this.formatPostalCode(value);
        default:
          return value;
      }
    },

    formatDate(value) {
      if (!value) return this.fallback;

      const date = moment(value);
      if (!date.isValid()) return value;

      return date.format('DD/MMM/YYYY').toLowerCase();
    },

    formatPhone(value) {
      if (!value) return this.fallback;

      const digits = String(value).replace(/\D/g, '');

      if (digits.length === 10) {
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(
          6
        )}`;
      }

      if (digits.length === 7) {
        return `${digits.slice(0, 3)}-${digits.slice(3)}`;
      }

      return value;
    },

    formatPostalCode(value) {
      if (!value) return this.fallback;

      const digits = String(value).replace(/\D/g, '');

      if (digits.length === 7) {
        return `${digits.slice(0, 3)}-${digits.slice(3)}`;
      }

      return value;
    },
  },
};
</script>
